<template>
    <section>
        <ui-breadcrumb title="Send Message" :items="['Projects', 'SMS', 'Send']"></ui-breadcrumb>
        <div class="content">
            <form class="mb-5" action="" method="POST" @submit.prevent="sendMessage">
                <div class="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
                    <div class="row">
                        <div class="col-lg-12 pb-2">
                            <el-tag
                                v-for="(recipient, index) in message.recipients"
                                :key="index"
                                closable
                                :disable-transitions="false"
                                @close="removeRecipient(index)"
                            >
                                {{recipient}}
                            </el-tag>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="recipient">Phone Number</label>
                                <vue-tel-input id="recipient" v-model="phoneNumber" @onInput="validatePhone"
                                               class="form-control"
                                               :preferredCountries="['ke', 'tz', 'ug']"/>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="sender-id">From</label>
                                <v-select :class="{'is-invalid': formErrors.from}"
                                          v-model="message.from"
                                          id="sender-id"
                                          label="senderName"
                                          :reduce="option => option.senderName"
                                          :options="shortCodes">
                                </v-select>
                                <div v-if="formErrors.from" :class="['invalid-feedback']">
                                    {{formErrors.from[0]}}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label for="message">Text Message</label>
                                <textarea :class="{'is-invalid': formErrors.message}" @blur="countCharacters"
                                          @keyup="countCharacters" id="message"
                                          class="form-control" v-model="message.message" rows="4"
                                          placeholder="Compose your message"/>
                                <span class='float-right text-right pt-1 pb-3 text-muted'
                                      :class="{'font-w700': messageCount > 1}">
                                    <small class="font-italic">{{messageCount}} Message(s) | {{remainingCount}}
                                        Characters Remaining
                                    </small>
                                </span>
                                <div v-if="formErrors.message" :class="['invalid-feedback']">
                                    {{formErrors.message[0]}}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group float-right">
                                <button type="submit" :class="['btn', 'btn-hero', 'btn-outline-success']">
                                    <span class="si si-control-play mr-2"/>
                                    Send Message
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import VueTelInput from 'vue-tel-input';
    import ShortCodeApi from '../../api/shortcodes';
    import VueSelect from 'vue-select';

    export default {
        name: "SendMessage",
        components: {
            'vue-tel-input': VueTelInput,
            'v-select': VueSelect
        },
        data() {
            return {
                shortCodes: [],
                formErrors: [],
                hasError: false,
                phoneNumber: '',
                messageCount: 1,
                remainingCount: 160,
                message: {
                    recipients: [],
                    from: '',
                    messageType: 'Bulk',
                    message: '',
                }
            }
        },
        beforeMount() {
            this.loadShortCodes();
        },
        methods: {
            validatePhone({number, isValid, country}) {
                if (isValid) {
                    this.phoneNumber = '';
                    this.message.recipients.push(number.replace(/\s/g, '').replace('+', ''));
                }
            },

            sendMessage() {
                let project = this.$route.params.project;

                axios.post(`web/projects/${project}/sms/simple/send`, this.message).then(res => {
                    this.$notify({
                        message: 'Message has been queued for dispatch',
                        title: 'Operation successful',
                        type: 'success'
                    });
                    this.$router.push(`/projects/${project}/sms/bulk-outbox`);
                }).catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.formErrors = error.response.data.errors;
                        this.hasError = true;
                    }
                })
            },

            loadShortCodes() {
                ShortCodeApi.getAllProjectShortCodes({
                    project: this.$route.params.project,
                    service: 'bulk'
                }).then(result => this.shortCodes = result);
            },

            countCharacters() {
                let count = Math.ceil(((this.message.message.length) / 160));
                this.messageCount = count === 0 ? 1 : count;
                this.remainingCount = 160 * this.messageCount - this.message.message.length;
            },
            removeRecipient(index) {
                this.message.recipients.splice(index, 1);
            }
        }
    }
</script>

<style scoped>

</style>
